import AreaChart from './area-chart';
export default AreaChart;
